<div class="flex flex-column consult__section consult__organ">
  <div class="consult__section-subheading-group flex-wrap">
    <h3 class="col-12 inline-flex align-items-center lg:col-6 p-0 consult__section-subheading cursor-pointer"
      (click)="expandSection = !expandSection">
      <i class="fas" [style.fontSize.px]="12" [ngClass]="{
        'fa-minus': expandSection,
        'fa-plus': !expandSection
      }"></i>
      <label class="ml-2 mb-0 cursor-pointer">{{screen.heading}}:</label>
    </h3>
    <span class="col-12 md:col-6 consult__section-help">{{screen.help}}</span>
  </div>

  <ng-container *ngIf="expandSection">
    <div class="flex hide-on-small" *ngIf="diagnostics.length > 0">
      <div class="col-fixed px-0" [style.width.px]="50" *ngIf="!readonly"></div>
      <label class="col no-margin" [ngClass]="{'pl-0': !readonly}"
        for="diagnostic_description_0_{{turn}}">{{screen.code}}</label>
      <label class="col-fixed px-0 text-center no-margin" [style.width.px]="60">{{screen.pre}}</label>
      <label class="col-fixed px-0 text-center no-margin" [style.width.px]="60">{{screen.def}}</label>
    </div>

    <div *ngFor="let diagnostic of diagnostics; let idx = index">
      <ms-general-consult-diagnostic-item [diagnostic]="diagnostic" (diagnosticChange)="addUpdateDiagnostic($event)"
        [idx]="idx" [turn]="turn" (remove)="removeDiagnostic(idx)" [readonly]="readonly"
        [canRemove]="diagnostics.length > 1">
      </ms-general-consult-diagnostic-item>
      <hr class="hide-from-small" />
    </div>

    <div class="text-center add-item-btn" *ngIf="!readonly">
      <button pButton icon="fas fa-plus" type="button" class="p-button-success p-button-rounded p-button-outlined"
        (click)="diagnostics.push({})">
      </button>
    </div>
  </ng-container>
</div>